export default __webpack_public_path__ + "static/media/sp-grey.e59a874c.svg";